import React, { useState } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import isNil from 'lodash.isnil';
import Color from '../../../enums/color';
import { getSimplifiedColorCode } from '../../../helpers/color';
import { ButtonAlign, ButtonClassType, IconPosition, ButtonIconSize, ButtonSizeCategory } from '../../../enums/buttons';
import { primaryButtonStyle, ghostButtonStyle, flatButtonStyle, iconButtonStyle } from './styles';
import { iconSizeStyles } from './styles/Icon';
const StyledButton = styled.button `
  border: unset;
  outline: none;
  color: ${Color.White};
  display: flex;
  justify-content: ${props => props.align};
  flex-direction: ${props => props.iconPosition === IconPosition.Left ? 'row' : 'row-reverse'};
  cursor: pointer;
  align-items: center;
  font-size: 14px;
  border-radius: 4px;

  svg {
    pointer-events: none;
  }

  ${iconSizeStyles}

  ${primaryButtonStyle}
  
  ${ghostButtonStyle}
  
  ${flatButtonStyle}
  
  ${iconButtonStyle}

  &.size-${ButtonSizeCategory.Large} {
    padding: 8px 16px;
    height: 32px;
    min-width: 136px;
  }
  
  &.size-${ButtonSizeCategory.Small} {
    padding: 2px;
  }

  &.icon-position-${IconPosition.Left} svg {
    margin-right: 8px;
  }

  &.icon-position-${IconPosition.Right} svg {
    margin-left: 8px;
  }
`;
const ButtonName = styled.div `
  line-height: normal;
`;
const Button = ({ name, type = 'button', classType = ButtonClassType.Primary, sizeCategory = ButtonSizeCategory.Large, colorTheme, icon, pressedIcon, disabled, automationId, className, align = ButtonAlign.Center, iconSize = ButtonIconSize.Small, iconPosition = IconPosition.Left, onMouseDown, disabledIcon, ...rest }) => {
    const { t: translate } = useTranslation();
    const [isPressed, setIsPressed] = useState(false);
    const mouseUpHandler = () => {
        setIsPressed(false);
        document.removeEventListener('mouseup', mouseUpHandler);
    };
    const handleMouseDown = (e) => {
        if (onMouseDown)
            onMouseDown(e);
        if (!pressedIcon)
            return;
        setIsPressed(true);
        document.addEventListener('mouseup', mouseUpHandler);
    };
    const getButtonColorTheme = () => {
        const defaultColorThemes = {
            [ButtonClassType.Primary]: Color.Apple,
            [ButtonClassType.Ghost]: Color.MicrosoftBlue,
            [ButtonClassType.Flat]: Color.MicrosoftBlue
        };
        return colorTheme || defaultColorThemes[classType];
    };
    return (<StyledButton {...rest} type={type} disabled={disabled} className={classnames(`kpmg-button-${classType}`, { [`size-${sizeCategory}`]: sizeCategory !== ButtonSizeCategory.Default }, { [`colorTheme-${getSimplifiedColorCode(getButtonColorTheme())}`]: !disabled && !isNil(getButtonColorTheme()) }, { 'disabled': disabled }, { [`icon-size-${iconSize}`]: icon }, { [`icon-position-${iconPosition}`]: iconPosition }, className)} data-automation-id={automationId} onMouseDown={handleMouseDown} align={align} iconPosition={iconPosition}>
      {disabled ? disabledIcon : isPressed ? pressedIcon : icon}
      {name ? <ButtonName>{translate(name)}</ButtonName> : ''}
    </StyledButton>);
};
export default Button;
